import { createApp, DirectiveBinding } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import { VueCookieNext } from 'vue-cookie-next';
import { translate } from '@/helpers/locale-helper';

import PerfectScrollbar from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
import VueAxios from 'vue-axios';
import axios from 'axios';

function updateTranslation(el: HTMLElement, binding: DirectiveBinding) {
    const lang = binding.instance?.$i18n.locale ?? process.env.VUE_APP_I18N_FALLBACK_LOCALE;
    el.innerHTML = translate(lang, binding.value);
}

createApp(App)
    .use(router)
    .use(VueAxios, axios)
    .use(i18n)
    .use(store)
    .use(VueCookieNext)
    .use(PerfectScrollbar)
    .directive('translate', {
        beforeUpdate(el: HTMLElement, binding: DirectiveBinding) {
            updateTranslation(el, binding);
        },
        beforeMount(el: HTMLElement, binding: DirectiveBinding) {
            binding.instance?.$watch('$i18n.locale', (value: string, _: string) => {
                el.innerHTML = translate(value, binding.value);
            });

            const timer = setInterval(() => {
                updateTranslation(el, binding);
                if (el.innerHTML.length > 0)
                    clearInterval(timer);
            }, 50);
        }
    })
    .mount('#layer2D');